<template>
  <v-row justify="center">
    <v-dialog v-model="open" max-width="400">
      <v-card>
        <v-card-title class="headline"> Problemas de Acesso </v-card-title>
        <v-card-text>
          Você digitou errado suas credenciais por 3 vezes seguidas.
          <br /><br />
          Por Favor
          <a href="https://egov.santos.sp.gov.br/sau/" target="blank">
            abra um SAU</a
          >
          contando-nos que está com problema de acesso e faremos os ajustes
          necessários.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="closeModal">
            CANCELAR
          </v-btn>
          <v-btn
            href="https://egov.santos.sp.gov.br/sau/"
            target="blank"
            color="green darken-1"
            text
            @click="closeModal"
          >
            ABRIR SAU
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      open: this.modalStatus,
    };
  },
  props: {
    modalStatus: Boolean,
  },
  methods: {
    closeModal() {
      this.$emit('closeFromModal');
    },
  },
};
</script>

<style>
a {
  text-decoration: none;
}
</style>
